// Shown on screens <640px wide. The notebook layout is intentionally tuned
// for desktop + tablet — phones already have the polished Expo app.

import { Icon } from './Icon';

export function MobileInterstitial() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
        padding: 28,
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 18,
          background: 'var(--rc-accent-soft)',
          color: 'var(--rc-accent)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name="sparkle" size={28} stroke={2.2} />
      </div>
      <div className="rc-kicker">Jotly</div>
      <h1 style={{ font: '700 24px/1.2 var(--rc-display)', margin: 0, letterSpacing: '-0.01em' }}>
        Open the Jotly app on your phone for the best small-screen experience.
      </h1>
      <p
        style={{
          font: '400 15px/1.5 var(--rc-sans)',
          color: 'var(--rc-ink-2)',
          margin: 0,
          maxWidth: 320,
        }}
      >
        This desktop view is built for a wider screen. The Jotly mobile app gives you the same
        capture, focus and chat on your phone.
      </p>
    </div>
  );
}
